import {navigation as mainNavigation} from "./routers/Navigation";

export const navigation = [...mainNavigation]